<template>
  <div class="collect-container">
    <TopList @setType="setType" :navList="navList"></TopList>
    <Collect1 v-if="type === 0"></Collect1>
    <Collect2 v-else-if="type === 1"></Collect2>
    <Collect3 v-else-if="type === 2"></Collect3>
    <CollectMeeting v-else-if="type === 3"></CollectMeeting>
    <CollectCourse v-else></CollectCourse>
  </div>
</template>

<script>
import TopList from "../../components/topList";
import Collect1 from "./components/Collect1.vue";
import Collect2 from "./components/Collect2.vue";
import Collect3 from "./components/Collect3.vue";
import CollectMeeting from "./components/CollectMeeting.vue";
import CollectCourse from "./components/CollectCourse.vue";
export default {
  name: "index",
  components: {
    TopList,
    Collect1,
    Collect2,
    Collect3,
    CollectMeeting,
    CollectCourse
  },
  data() {
    return {
      navList: ["资讯", "文献", "征稿函","会议","课程"],
      type: 0,
    };
  },
  methods: {
    setType(e) {
      this.type = e;
    },
  },
};
</script>
